// extracted by mini-css-extract-plugin
module.exports = {"button":"PackagesTypesList_button__2JNlg","addButton":"PackagesTypesList_addButton__1CxrH"};